<template>
  <li class="sidebarItem tickFilter" :class="{ticked: ticked}" @click="onclick">
      <input type="checkbox" :checked="ticked"/>
      <slot/>
  </li>
</template>

<script>

export default {
  name: 'TickFilter',
  props: ["ticked", "onclick"]
}
</script>

<style lang="scss" scoped>
    .tickFilter{
        padding:2px;
        user-select: none;
    }

</style>
